module.exports = __webpack_public_path__ + "static/media/eamonn.5f9e47e8.png";